import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// TODO: ideally this would be Promise-based so that we can defer loading Model classes until they're needed.

export default class ModelFactory {
  constructor() {
    _defineProperty(this, "_constructors", new Map());
  }
  get constructorsArray() {
    return Array.from(this._constructors);
  }
  register(type, constructor) {
    this._constructors.set(type, constructor);
  }
  create(type, uniqueId, terria, sourceReference) {
    if (!type) return undefined;
    const Constructor = this._constructors.get(type);
    if (Constructor === undefined) {
      return undefined;
    }
    return new Constructor(uniqueId, terria, sourceReference);
  }
  find(type) {
    return this._constructors.get(type);
  }
}